// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-based-form {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;
}

.role-based-form::-webkit-scrollbar {
  width: 6px;
}

.role-based-form::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.form-section {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
}

.form-section:last-of-type {
  border-bottom: none;
}

.form-section h4 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: var(--primary-color);
  font-size: 16px;
}

.form-section h4 i {
  font-size: 18px;
}

.required {
  color: var(--danger-color);
  font-weight: bold;
  margin-left: 2px;
}

.form-input.error {
  border-color: var(--danger-color);
}

.error-text {
  color: var(--danger-color);
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

.role-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 10px;
  background: #eff6ff;
  border-left: 3px solid var(--info-color);
  border-radius: 6px;
  font-size: 12px;
  color: #1e40af;
}

.role-info i {
  font-size: 14px;
}

.password-input {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input input {
  flex: 1 1;
  padding-right: 45px;
}

.toggle-password {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.toggle-password:hover {
  color: var(--primary-color);
  background: var(--light-color);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn i {
  font-size: 14px;
}

.btn-primary {
  background: var(--primary-color);
  color: white;
}

.btn-primary:hover {
  background: #4338ca;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.4);
}

.btn-secondary {
  background: var(--text-secondary);
  color: white;
}

.btn-secondary:hover {
  background: #4b5563;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .role-based-form {
    max-height: 60vh;
  }

  .form-section h4 {
    font-size: 14px;
  }

  .form-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RoleBasedEmployeeForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".role-based-form {\n  max-height: 70vh;\n  overflow-y: auto;\n  padding-right: 10px;\n}\n\n.role-based-form::-webkit-scrollbar {\n  width: 6px;\n}\n\n.role-based-form::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 3px;\n}\n\n.form-section {\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.form-section:last-of-type {\n  border-bottom: none;\n}\n\n.form-section h4 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 20px;\n  color: var(--primary-color);\n  font-size: 16px;\n}\n\n.form-section h4 i {\n  font-size: 18px;\n}\n\n.required {\n  color: var(--danger-color);\n  font-weight: bold;\n  margin-left: 2px;\n}\n\n.form-input.error {\n  border-color: var(--danger-color);\n}\n\n.error-text {\n  color: var(--danger-color);\n  font-size: 12px;\n  margin-top: 5px;\n  display: block;\n}\n\n.role-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 10px;\n  background: #eff6ff;\n  border-left: 3px solid var(--info-color);\n  border-radius: 6px;\n  font-size: 12px;\n  color: #1e40af;\n}\n\n.role-info i {\n  font-size: 14px;\n}\n\n.password-input {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input input {\n  flex: 1;\n  padding-right: 45px;\n}\n\n.toggle-password {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n}\n\n.toggle-password:hover {\n  color: var(--primary-color);\n  background: var(--light-color);\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 15px;\n  margin-top: 30px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-color);\n}\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn i {\n  font-size: 14px;\n}\n\n.btn-primary {\n  background: var(--primary-color);\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #4338ca;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.4);\n}\n\n.btn-secondary {\n  background: var(--text-secondary);\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #4b5563;\n  transform: translateY(-2px);\n}\n\n@media (max-width: 768px) {\n  .role-based-form {\n    max-height: 60vh;\n  }\n\n  .form-section h4 {\n    font-size: 14px;\n  }\n\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
